Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconGeopinData: "data:image/svg+xml,%3csvg width='16' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg transform='translate(-4)' stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3ccircle cx='12' cy='8' r='3'/%3e%3cpath d='M5 8a7 7 0 0114 0M19 8a19.05 19.05 0 01-7 15M5 8a19.06 19.06 0 007 15'/%3e%3c/g%3e%3c/svg%3e",
  iconGeopinWidth: 16,
  iconGeopinHeight: 24
};